<template>
    <div>
        <Breadcrumb></Breadcrumb>
        <el-row class="tools-box">
            <el-row :gutter="16">
                <el-col :span="8" class="tools-item" v-for="(item, index) in toolsList" :key="index">
                    <el-row class="tools-item-content" type="flex" justify="left" @click.native="toolsHandler(index)">
                        <img :src="item.src" class="tools-batch">
                        <div>
                            <el-row type="flex" justify="left">
                            <h6>{{item.name}}</h6>
                            <img src="../../assets/images/jt.png" class="tools-arrow">
                            </el-row>
                            <div class="tools-desc">{{item.desc}}</div>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </el-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            toolsList: [
                {src: require('../../assets/images/tools-list.png'),name: '排行榜',desc: '查询不同类别的院校排行',path: ''},
                {src: require('../../assets/images/tools-batch.png'),name: '批次线查询',desc: '查询近五年录取批次线',path: ''},
                {src: require('../../assets/images/tools-rank.png'),name: '位次查询',desc: '查询当年对应位次',path: ''},
                {src: require('../../assets/images/tools-score.png'),name: '艺术分数换算',desc: '查询不同院校文化课成绩与艺术成绩比例',path: ''}
            ],
        }
    },
    methods: {
        toolsHandler(index) {
            switch(index){
                case 0:
                    this.$router.push({
                        path: "/rank"
                    });
                break;
                case 1:
                    this.$router.push({
                        path: "/tools-batch"
                    });
                break;
                case 2:
                    this.$router.push({
                        path: "/tools-rank"
                    });
                break;
                case 3:
                    this.$router.push({
                        path: "/tools-score"
                    });
                break;
                default:
                    break;
                }
            }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
.tools-box {
    @include gwidth;
    margin-top: 30px;
    border: none;
    background: #fff;
    box-shadow: none !important;
    padding: 24px 24px 0 24px;
    box-sizing: border-box;
    .tools-title {
        font-size: 18px;
        font-weight: 600;
        color: #2c2e33;
        font-weight: 600;
        text-align: left;
        margin-bottom: 20px;
    }
    .tools-img {
        width: 20px;
        height: 20px;
        position: relative;
        top: 2px;
    }
    .infor-right {
        text-align: right;
        a {
            text-decoration:none;
            color: #3272ff;
            font-size: 14px;
            cursor: pointer;
        }
        img {
            width: 14px;
            height: 14px;
            margin-left: 2px;
            position: relative;
            top: 2px;
        }
    }
    .tools-item {
        margin-bottom: 24px;
    }
    .tools-item-content {
        height: 140px;
        border: 1px solid #ebedf0;
        border-radius: 10px;
        box-shadow: 0px 0px 7px 0px rgba(44,46,51,0.10); 
        padding: 20px 14px 20px 20px;
        background: #ffffff;
        box-sizing: border-box;
        .tools-batch {
            width: 100px;
            height: 100px;
        }
        h6 {
            font-size: 18px;
            font-weight: 500;
            color: #2c2e33;
            margin: 0;
            margin: 6px 8px 0 16px;
        }
        .tools-arrow {
            width: 15px;
            height: 14px;
            position: relative;
            top: 9px;
        }
        .tools-desc {
            font-size: 14px;
            color: #5e6166;
            font-weight: 400;
            text-align: left;
            margin-left: 16px;
            margin-top: 14px;
            line-height: 22px;
        }
        }
        .tools-item-content:hover {
            background: #f5f7fa;
            cursor: pointer;
        }
    }
</style>